module.exports = __webpack_public_path__ + "static/img/6.3de1b78.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/sp/6.png
// module id = R3ks
// module chunks = 0